<div class="kt-grid kt-grid--ver kt-grid--root kt-page" style="min-height: 100vh;">
    <div class="kt-grid kt-grid--hor kt-grid--root  kt-login kt-login--v1" id="kt_login">
        <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">

            <!--begin::Aside-->
            <div class="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
                style="background-color: #005BAA;">
                <div class="kt-grid__item">

                    <div class="kt-login__info">
                        <a routerLink="/login" class="kt-login__logo">
                            <img src="assets/img/bkd_siyah_zeminsiz.png" width="160" height="53" style="margin-right: 30px;">
                            <img src="assets/img/boost-logo.png" width="180" height="70">
                        </a>
                        <!-- <div class="kt-login__menu">
                            <a href="https://www.bilimkahramanlari.org/iletisim/" target="_blank" class="kt-link">İletişim</a>
                            <a href="https://fonzip.com/bilimkahramanlari/bagis#/" target="_blank" class="kt-link">Bağış</a>
                            <a routerLink="/kvkk" class="kt-link">KVKK</a>
                        </div> -->
                    </div>
                </div>
                <!-- <div class="kt-grid__item" style="margin-top: 20px;">
                    <div class="kt-login__info">
                        <img src="assets/img/foto1.jpg" style="width: 33%;">
                        <img src="assets/img/foto2.jpg" style="width: 33%;">
                        <img src="assets/img/foto3.JPG" style="width: 33%;">
                    </div>
                </div> -->
                <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
                    <div class="kt-grid__item kt-grid__item--fluid" style="margin-top: 25px;">
                        <h3 class="kt-login__title" style="text-align: center;">Bilim Kahramanları Derneği <br> Gönüllü Portalı'na<br> Hoş Geldin!</h3>
                        <!-- <h4 class="kt-login__subtitle" style="color: #000;">Bilim Kahramanları Derneği Gönüllü Portalı'na Hoş Geldin!</h4> -->
                    </div>
                </div>
                <div class="kt-grid__item" style="margin-top: 5px;">
                    <div class="kt-login__info">
                        <img src="assets/img/foto1.jpg" style="width: 50%;">
                        <img src="assets/img/foto2.jpg" style="width: 50%;">
                    </div>
                </div>
                 <div class="kt-grid__item" style="margin-top: 20px;">
                    <div class="kt-login__info">
                        <img src="assets/img/foto4.jpg" style="width: 100%;">
                    </div>
                </div>
                <!-- <div class="kt-grid__item">
                    <div class="kt-login__info">
                        <div class="kt-login__copyright">
                        </div>

                    </div>
                </div> -->
            </div>

            <!--begin::Aside-->

            <!--begin::Content-->
            <div class="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">

                <!--begin::Head-->
                <div class="kt-login__head">
                    <span class="kt-login__signup-label">Hesabın yok mu?</span>&nbsp;&nbsp;
                    <a routerLink="/register" class="kt-link kt-login__signup-link">Hesap oluştur!</a>
                </div>

                <!--end::Head-->

                <!--begin::Body-->
                <div class="kt-login__body">

                    <!--begin::Signin-->
                    <div class="kt-login__form">
                        <div class="kt-login__title">
                            <h3>Şifreni mi unuttun?</h3>
                        </div>

                        <!--begin::Form-->
                        <form class="kt-form" action="" novalidate="novalidate" id="kt_login_form">
                            <div class="form-group">
                                <input [(ngModel)]="model.email" class="form-control" type="text" placeholder="Email" name="email" autocomplete="off">
                            </div>

                            <!--begin::Action-->
                            <div class="kt-login__actions">
                                <button id="kt_login_signin_submit" class="btn btn-dark btn-elevate kt-login__btn-primary" (click)="navigateToLogin()">Vazgeç</button>
                                <button id="kt_login_signin_submit" class="btn btn-primary btn-elevate kt-login__btn-primary" (click)="reset()">Şifremi sıfırla</button>
                            </div>

                            <!--end::Action-->
                        </form>

                        <!--end::Form-->
                    </div>

                    <!--end::Signin-->
                </div>

                <!--end::Body-->
            </div>

            <!--end::Content-->
        </div>
    </div>
</div>